import JobPreviewComponent from './JobPreviewComponent';

export default JobPreviewComponent;
